import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const TypedCell = (column: GridColumnConfig) => {
  if (column.fieldType === 'currency') {
    return (dataItem: any) => {
      const data = dataItem.dataItem[column.field];
      return <td>{!!data && data >= 0 && `$${dataItem.dataItem[column.field]}`}</td>;
    };
  }
};
